"use strict";

exports.__esModule = true;
exports.default = void 0;

var _listGroup = _interopRequireDefault(require("./list-group"));

var _listGroupItem = _interopRequireDefault(require("./list-group-item"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BListGroup: _listGroup.default,
  BListGroupItem: _listGroupItem.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/list-group/index.js
// module id = 392
// module chunks = 0